import { render, staticRenderFns } from "./DeliveryTable.vue?vue&type=template&id=159b2f23&"
import script from "./DeliveryTable.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports